import React from 'react';
import PropTypes from 'prop-types';
import {
  isNodeEmpty,
  ORDERED_LIST_DEFINITIONS,
  Placeholder,
} from '@xingternal/content-editor-plugin-helpers';

import { ORDERED_LIST_TAG_NAME } from './constants';

const OrderedList = ({
  className,
  ORDERED_LIST_TAG = ORDERED_LIST_TAG_NAME,
  ...attributes
}) => {
  const RenderLeaf = ({
    children,
    element,
    attributes: elementAttributes,
  } = {}) => {
    if (element.type === ORDERED_LIST_DEFINITIONS.type) {
      const { placeholder, ...restOfAttributes } = attributes;

      if (placeholder && isNodeEmpty(element)) {
        return (
          <ORDERED_LIST_TAG {...elementAttributes}>
            {Placeholder(children, className, placeholder)}
          </ORDERED_LIST_TAG>
        );
      }

      return (
        <ORDERED_LIST_TAG
          {...restOfAttributes}
          {...elementAttributes}
          data-editor-plugin={ORDERED_LIST_DEFINITIONS.type}
          className={className}
        >
          {children}
        </ORDERED_LIST_TAG>
      );
    }
  };
  return RenderLeaf;
};

OrderedList.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  ORDERED_LIST_TAG: PropTypes.node,
};

export { OrderedList };
